import { Injectable } from '@angular/core';
import { IFilter } from '@shared/interfaces/filter.interface';
import { ILocation } from '@shared/interfaces/location.interface';
import { Filter } from '@shared/models/filter.model';
import { LocationsService } from '@shared/services/locations.service';
import { LoggerService } from '@shared/services/logger.service';
import { PaginationService } from '@shared/services/pagination/pagination.service';

@Injectable({
  providedIn: 'root'
})
export class PaginationLocationsService extends PaginationService<ILocation> {
  private static readonly DEFAULT_IS_DELETED_FILTER: IFilter = {
    label: 'COMMON.ACTIVE',
    key: 'isDeleted',
    value: 'false'
  };

  // private static readonly DEFAULT_OWNERSHIP_FILTER: IFilter = {
  //   label: 'FILTERS.MYSELF',
  //   key: '',
  //   value: ''
  // };

  private static readonly DEFAULT_SEARCH_FILTER: IFilter = {
    key: 'search',
    value: null
  };

  private _filtersScope: any;

  constructor(_paginable: LocationsService, _logger: LoggerService) {
    super(_paginable, _logger);

    this.setFilters([
      PaginationLocationsService.DEFAULT_IS_DELETED_FILTER,
      // PaginationLocationsService.DEFAULT_OWNERSHIP_FILTER,
      PaginationLocationsService.DEFAULT_SEARCH_FILTER
    ]);
  }

  public getFilters(): IFilter[] {
    return this._filtersScope;
  }

  public reset() {
    super.reset();

    this.setFilters([
      PaginationLocationsService.DEFAULT_IS_DELETED_FILTER,
      // PaginationLocationsService.DEFAULT_OWNERSHIP_FILTER,
      PaginationLocationsService.DEFAULT_SEARCH_FILTER
    ]);
  }

  public setFilters(filters: Partial<IFilter>[]): void {
    this._filtersScope = filters.map((f) => new Filter(f));
    super.setFilters(this._filtersScope);
  }
}
